import { validationSchemaSubmitForm, validationSchemaWhyRevoke } from '../SubmitValidationSchemas';
import { FormDataSubmit } from '../types.ts';

type ValidationSchema =
  | ReturnType<typeof validationSchemaSubmitForm>
  | ReturnType<typeof validationSchemaWhyRevoke>
  | null;

interface IFormConfig {
  validationSchema: ValidationSchema;
}

export const getSubmitFormConfig = (
  current: number,
  formData?: FormDataSubmit
): IFormConfig => {
  if (current === 1) {
    return {
      validationSchema: validationSchemaSubmitForm(formData),
    };
  }

  if (current === 3) {
    return {
      validationSchema: validationSchemaWhyRevoke(),
    };
  }

  return {
    validationSchema: null,
  };
};
